import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import StickyStory from '../components/marketing/StickyStory';
import studentBook from '../assets/images/student-book.png';

export default function HowItWorksPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <div className="mk-page-hero-grid">
            <div>
              <span className="mk-eyebrow">How it works</span>
              <h1>Enroll, choose a plan, then study.</h1>
              <p>The portal opens after payment. The tutor stays available while you prepare.</p>
              <div className="mk-inline-actions" style={{ marginTop: 20 }}>
                <Link to="/signup" className="mk-btn mk-btn-primary">
                  Enroll
                </Link>
                <Link to="/pricing" className="mk-btn mk-btn-secondary">
                  Compare plans
                </Link>
              </div>
            </div>
            <div className="mk-page-photo-card mk-page-photo-tall">
              <img src={studentBook} alt="Student studying for the GED" />
            </div>
          </div>
        </div>
      </header>

      <StickyStory />
    </MarketingLayout>
  );
}
